












































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  IcoachSkillFullInfo,
  SurveyInfo,
  TsManagerUser,
  TsRateeUser,
  TsRaterRateeSkillRating,
  TsRatingForm,
  TsUserDto,
  TsUserRole,
  User
} from '@/interfaces'
import { Getter } from 'vuex-class'
import RaterRateeCard from '@/components/360/RaterRateeCard.vue'
import TsService from '@/services/TsService'
import RangeSlider from '@/components/common/rangeSlider/RangeSlider.vue'
import PerformanceManagerCard from '@/components/360/PerformanceManagerCard.vue'
import AppFooter from '@/components/footer/AppFooter.vue'

@Component({
  name: 'RaterRateeSkillPage',
  components: {
    RaterRateeCard,
    PerformanceManagerCard,
    RangeSlider,
    AppFooter
  }
})
export default class RaterRateeSkillPage extends Vue {
  @Prop({ required: true })
  tsSurveyId !: number

  @Prop({ required: true })
  tsRaterRateeId !: number

  @Prop({ required: true })
  skillId !: number

  @Getter('user/currentUser')
  user!: User

  @Getter('ts/getUsers')
  tsUserInfo!: TsUserDto

  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Getter('ts/hasRoleRatee')
  hasRoleRatee!: boolean

  @Getter('ts/hasRoleRater')
  hasRoleRater!: boolean

  @Getter('ts/hasRoleManager')
  hasRoleManager!: boolean

  @Getter('survey/getDisplayedBaseSurveyInfo')
  surveyInfo!: SurveyInfo

  ratee: TsRateeUser | null = null
  skillInfo: IcoachSkillFullInfo | null = null
  rating: TsRaterRateeSkillRating | null = null
  ratingForm: TsRatingForm = { comment: '', score: 1 }
  myPerformanceManager: TsManagerUser | null = null
  rateeMobileNav: boolean = false;
  ratings: number[] = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
  ]

  async created () {
    if (!this.isAuthenticated) {
      await this.$router.push({ name: 'notFound' })
    }

    if (!this.ratee) {
      this.ratee = await TsService.getRateeInfoById(this.tsRaterRateeId)
    }

    if (!this.skillInfo) {
      this.skillInfo = await TsService.getSkillInfo(this.tsRaterRateeId, this.skillId)
    }

    if (this.skillInfo && this.skillInfo.status) {
      this.rating = await TsService.getRating(this.tsRaterRateeId, this.skillInfo.id)
    }

    await this.uploadMyPerformanceManager()
  }

  goToList (): void {
    this.$router.push({
      name: 'survey.ts.user.ratee',
      params: {
        tsRaterRateeId: this.tsRaterRateeId.toString()
      }
    })
  }

  updateValues (value: string) {
    this.ratingForm.score = parseInt(value) / 10
  }

  async toggleRateeMobileNav () {
    this.rateeMobileNav = !this.rateeMobileNav
  }

  async rate () {
    if (!await this.$validator.validateAll()) {
      return
    }

    try {
      const result = await TsService.addRating(this.tsRaterRateeId, this.skillId, this.ratingForm)

      this.updateRating(result)
    } catch (error) {
      if ('response' in error && error.response.status === 400) {
        this.handleSkillRatingErrors(error.response.data)
      }
    }
  }

  async uploadMyPerformanceManager () {
    if (this.hasRoleRatee) {
      const currentRatee = this.tsUserInfo.users.find(user => user.role === TsUserRole.RATEE)
      if (!currentRatee) {
        return
      }

      this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATEE, currentRatee.id)
    } else if (this.hasRoleRater) {
      if (!this.ratee) {
        return
      }

      this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATER, this.ratee.id)
    }
  }

  scoreFormatFromString (score: string): string {
    return parseFloat(score).toFixed(1)
  }

  updateRating (rating: TsRatingForm) {
    this.rating = {
      comment: rating.comment,
      score: rating.score
    }
    this.ratingForm = {
      score: 1,
      comment: ''
    }

    if (this.skillInfo) {
      this.skillInfo.status = true
    }
  }

  handleSkillRatingErrors (data: object) {
    // todo::add handle logic
  }
}
